module.exports = __webpack_public_path__ + "img/flexsale_hifi_2.c65acd0f.png";